import { cx } from '@twind/core';
import { ContactFormLinkLocation } from 'app/modules/contact-form/stores/ContactFormStore';
import MessageBubble from 'app/modules/live-chat/components/MessageBubble';
import { ChatItemMessage, ChatItemSourceType } from 'app/services/chatBot';
import React from 'react';

import OstroDynamicContent from '../../../../components/OstroDynamicContent';
import useVirtualAssistantAvatar from '../../hooks/useVirtualAssistantAvatar';
import BaseChatItem from './BaseChatItem';

export default function MessageChatItem({
  chatItem,
  hideAvatar,
  onClickContent,
  className,
}: {
  chatItem: ChatItemMessage;
  onClickContent?: (e: React.MouseEvent, item: ChatItemMessage, linkLocation?: ContactFormLinkLocation) => void;
  hideAvatar?: boolean;
  className?: string;
}) {
  const avatarURL = useVirtualAssistantAvatar();
  const onClickWrapper = (e: React.MouseEvent) => {
    if (onClickContent) {
      onClickContent(e, chatItem, 'vaResponse');
    }
  };

  switch (chatItem.source) {
    case ChatItemSourceType.PATIENT:
      return (
        <BaseChatItem
          showAvatar={false}
          className="flex-row"
        >
          <MessageBubble
            className="bg-virtualAssistant-selectedOptionBackgroundColor"
            isAuthor={true}
          >
            {chatItem.message || ''}
          </MessageBubble>
        </BaseChatItem>
      );
    case ChatItemSourceType.PATIENT_CHOICE:
      return (
        <BaseChatItem
          showAvatar={false}
          className="flex-row"
        >
          <MessageBubble
            className="bg-virtualAssistant-selectedOptionBackgroundColor"
            isAuthor={true}
          >
            <span dangerouslySetInnerHTML={{ __html: chatItem.message || '' }} />
          </MessageBubble>
        </BaseChatItem>
      );
    default:
      return (
        <BaseChatItem
          avatarURL={avatarURL}
          className={cx('ostro-chat-item-message', className)}
          showAvatar={!hideAvatar}
        >
          <OstroDynamicContent
            content={(chatItem as ChatItemMessage).message}
            onClick={onClickWrapper}
            className="[&_p:last-child]:mb-0"
          />
        </BaseChatItem>
      );
  }
}
